var loadingAnimationData = {
  v: '5.1.1',
  fr: 29.9700012207031,
  ip: 1.00000004073083,
  op: 175.000007127896,
  w: 128,
  h: 128,
  nm: 'Loading',
  ddd: 0,
  assets: [],
  layers: [{
    ddd: 0,
    ind: 1,
    ty: 3,
    nm: 'Null 2',
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 0,
        ix: 11
      },
      r: {
        a: 1,
        k: [{
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ['0p833_0p833_0p167_0p167'],
          t: 0,
          s: [0],
          e: [-130]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ['0p833_0p833_0p167_0p167'],
          t: 59,
          s: [-130],
          e: [-270]
        }, {
          i: {
            x: [0.833],
            y: [0.833]
          },
          o: {
            x: [0.167],
            y: [0.167]
          },
          n: ['0p833_0p833_0p167_0p167'],
          t: 117,
          s: [-270],
          e: [-360]
        }, {
          t: 176.000007168627
        }],
        ix: 10
      },
      p: {
        a: 0,
        k: [64, 64, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    ip: 0,
    op: 900.000036657751,
    st: 0,
    bm: 0
  }, {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: 'Circle 3',
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [0.274, 0.103, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [114.584, 114.584],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0.188235294118, 0.03137254902, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 12,
          ix: 5
        },
        lc: 2,
        lj: 2,
        d: [{
          n: 'd',
          nm: 'dash',
          v: {
            a: 0,
            k: 22.5,
            ix: 1
          }
        }, {
          n: 'o',
          nm: 'offset',
          v: {
            a: 0,
            k: 0,
            ix: 7
          }
        }],
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [-0.019, -0.196],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.118],
            y: [1]
          },
          o: {
            x: [0.864],
            y: [0]
          },
          n: ['0p118_1_0p864_0'],
          t: 116,
          s: [100],
          e: [0]
        }, {
          t: 146.000005946702
        }],
        ix: 1
      },
      e: {
        a: 1,
        k: [{
          i: {
            x: [0.067],
            y: [0.996]
          },
          o: {
            x: [0.955],
            y: [0]
          },
          n: ['0p067_0p996_0p955_0'],
          t: 146,
          s: [100],
          e: [0]
        }, {
          t: 175.000007127896
        }],
        ix: 2
      },
      o: {
        a: 0,
        k: 0,
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 116.000004724777,
    op: 175.000007127896,
    st: 116.000004724777,
    bm: 0
  }, {
    ddd: 0,
    ind: 3,
    ty: 4,
    nm: 'Circle 2',
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [0.274, 0.103, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [114.584, 114.584],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0.188235294118, 0.03137254902, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 12,
          ix: 5
        },
        lc: 2,
        lj: 2,
        d: [{
          n: 'd',
          nm: 'dash',
          v: {
            a: 0,
            k: 22.5,
            ix: 1
          }
        }, {
          n: 'o',
          nm: 'offset',
          v: {
            a: 0,
            k: 0,
            ix: 7
          }
        }],
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [-0.019, -0.196],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.118],
            y: [1]
          },
          o: {
            x: [0.864],
            y: [0]
          },
          n: ['0p118_1_0p864_0'],
          t: 58,
          s: [100],
          e: [0]
        }, {
          t: 88.0000035843135
        }],
        ix: 1
      },
      e: {
        a: 1,
        k: [{
          i: {
            x: [0.067],
            y: [0.996]
          },
          o: {
            x: [0.955],
            y: [0]
          },
          n: ['0p067_0p996_0p955_0'],
          t: 88,
          s: [100],
          e: [0]
        }, {
          t: 117.000004765508
        }],
        ix: 2
      },
      o: {
        a: 0,
        k: 0,
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 58.0000023623884,
    op: 117.000004765508,
    st: 58.0000023623884,
    bm: 0
  }, {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: 'Circle',
    parent: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [-0.673, 0.423, 0],
        ix: 2
      },
      a: {
        a: 0,
        k: [0, 0, 0],
        ix: 1
      },
      s: {
        a: 0,
        k: [100, 100, 100],
        ix: 6
      }
    },
    ao: 0,
    shapes: [{
      ty: 'gr',
      it: [{
        d: 1,
        ty: 'el',
        s: {
          a: 0,
          k: [114.584, 114.584],
          ix: 2
        },
        p: {
          a: 0,
          k: [0, 0],
          ix: 3
        },
        nm: 'Ellipse Path 1',
        mn: 'ADBE Vector Shape - Ellipse',
        hd: false
      }, {
        ty: 'st',
        c: {
          a: 0,
          k: [1, 0.188235294118, 0.03137254902, 1],
          ix: 3
        },
        o: {
          a: 0,
          k: 100,
          ix: 4
        },
        w: {
          a: 0,
          k: 12,
          ix: 5
        },
        lc: 2,
        lj: 2,
        d: [{
          n: 'd',
          nm: 'dash',
          v: {
            a: 0,
            k: 22.5,
            ix: 1
          }
        }, {
          n: 'o',
          nm: 'offset',
          v: {
            a: 0,
            k: 0,
            ix: 7
          }
        }],
        nm: 'Stroke 1',
        mn: 'ADBE Vector Graphic - Stroke',
        hd: false
      }, {
        ty: 'tr',
        p: {
          a: 0,
          k: [-0.019, -0.196],
          ix: 2
        },
        a: {
          a: 0,
          k: [0, 0],
          ix: 1
        },
        s: {
          a: 0,
          k: [100, 100],
          ix: 3
        },
        r: {
          a: 0,
          k: 0,
          ix: 6
        },
        o: {
          a: 0,
          k: 100,
          ix: 7
        },
        sk: {
          a: 0,
          k: 0,
          ix: 4
        },
        sa: {
          a: 0,
          k: 0,
          ix: 5
        },
        nm: 'Transform'
      }],
      nm: 'Ellipse 1',
      np: 3,
      cix: 2,
      ix: 1,
      mn: 'ADBE Vector Group',
      hd: false
    }, {
      ty: 'tm',
      s: {
        a: 1,
        k: [{
          i: {
            x: [0.118],
            y: [1]
          },
          o: {
            x: [0.864],
            y: [0]
          },
          n: ['0p118_1_0p864_0'],
          t: 0,
          s: [100],
          e: [0]
        }, {
          t: 30.0000012219251
        }],
        ix: 1
      },
      e: {
        a: 1,
        k: [{
          i: {
            x: [0.067],
            y: [0.996]
          },
          o: {
            x: [0.955],
            y: [0]
          },
          n: ['0p067_0p996_0p955_0'],
          t: 30,
          s: [100],
          e: [0]
        }, {
          t: 59.0000024031193
        }],
        ix: 2
      },
      o: {
        a: 0,
        k: 0,
        ix: 3
      },
      m: 1,
      ix: 2,
      nm: 'Trim Paths 1',
      mn: 'ADBE Vector Filter - Trim',
      hd: false
    }],
    ip: 0,
    op: 59.0000024031193,
    st: 0,
    bm: 0
  }],
  markers: []
};

export { loadingAnimationData as default };
